import { useFeature } from 'flagged';

import { FeatureFlags } from '../client';

export function useRequireFeatureFlagIfProvided<K extends keyof FeatureFlags>(name?: K) {
  const featureFlagValue = useFeature(name === undefined ? 'always_on' : name);
  return name === undefined ? true : featureFlagValue;
}
